enum AnswerVisibility {
	Never = "never",
	AfterSubmission = "after_submission",
	AfterDeadline = "after_deadline",
	Always = "always",
}

export default AnswerVisibility;
